import { put, call, all, fork, select, takeLatest } from "redux-saga/effects";
import { sectorsApiUpsellProvider } from "../../lib/api/providers";
import {
  // USER_GET_SECTORS_LIST,
  GET_ALL_SECTORS_LIST,
  SET_ALL_SECTORS_LIST
} from "../types";

const getAuthState = state => state.auth;
const getState = state => state;

const getUserSectorsListApi = (stateAuth, state) => {
  return sectorsApiUpsellProvider
    .post(
      "/",
      {
        match: {
          client_id: state.currentClient.id
        },
        project: {
          sector_id: 1,
          sector_label: 1,
          client_id: 1,
          client_label: 1
        }
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => response.data);
};

function* getUserSectorsList() {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getState);
    const data = yield call(getUserSectorsListApi, stateAuth, state);

    yield put({ type: SET_ALL_SECTORS_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* watchGetUserSectorsList() {
  yield takeLatest(GET_ALL_SECTORS_LIST, getUserSectorsList);
}

export default function* root() {
  yield all([fork(watchGetUserSectorsList)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/allSectorsSagas.js